import { TRoleItem } from "@/data/types";
import { State } from "../state/state";

export const getAllRoles = (state: State): TRoleItem[] => state.roles.items;

export const getCurrentRole = (state: State): TRoleItem | null =>
  state.roles.currentRole;